import { Box, styled } from "@mui/material";

export const GroupsMessageBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  fontSize: "20px"
});
